import { ICombination } from '../../../types/interfaces';
import { buildDocUrlForAdjustedSurface } from '../libs/artworkUrlBuilder';

export class Combination {
  public static readonly SubstrateColorKey = 'Substrate Color';

  constructor(
    private _combination: ICombination,
    private _isInitial: boolean = false
  ) {}

  get optionSelections(): string {
    return JSON.stringify(this._combination);
  }

  get isEmpty(): boolean {
    return Object.keys(this._combination).length === 0;
  }

  get combination(): ICombination {
    return this._combination;
  }

  get isInitial(): boolean {
    return this._isInitial;
  }

  isCompatible(other: Combination, ...excludedAttributes: string[]): boolean {
    return !Object.keys(this._combination)
      .filter((attributeKey) => !excludedAttributes.includes(attributeKey))
      .some((key) => other._combination[key] && this._combination[key] !== other._combination[key]);
  }

  equals(other: Combination): boolean {
    return (
      this._isInitial === other._isInitial &&
      Object.keys(this._combination).length === Object.keys(other._combination).length &&
      !Object.keys(this._combination).some(
        (key) => other._combination[key] && this._combination[key] !== other._combination[key]
      )
    );
  }

  static empty(): Combination {
    return new Combination({});
  }

  getDocumentUrlAdaptedToOptions(
    locale: string,
    productKey: string,
    productVersion: number,
    documentUrl: string
  ): string {
    const selectedSubstrateColor = this._combination[Combination.SubstrateColorKey];

    return buildDocUrlForAdjustedSurface(
      documentUrl,
      productKey,
      productVersion,
      selectedSubstrateColor,
      this._combination,
      locale
    );
  }

  copy(): Combination {
    return new Combination(this._combination, this._isInitial);
  }
}
